/** @format */

export interface Attributes {
  createdDttm: string;
  createdUser: string;
  id: string;
  status: string;
  updatedDttm: string;
  updatedUser: string;
  value: string;
}

export interface PartyResponse {
  attributes: Attributes[];
  identityId: string;
}
